export default __webpack_public_path__ + "bfa616b5b8c4b40f77f8745ae286f67d.png";